/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditNewScorecardAttributeNewValueRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit.new-scorecard.attribute-new.value',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditNewScorecardAttributeNewValueRoute);
